export default "__VITE_ASSET__D52DlSeq__"